import React, { useEffect, useState } from "react";
import { useLang } from "@/contexts/LanguageContext";
import api from "@/lib/api";
import { Sparkles } from "lucide-react";

export default function News() {
  const { t, lang } = useLang();
  const [posts, setPosts] = useState([]);
  const [cat, setCat] = useState("all");
  const cats = t("news.categories");

  useEffect(() => {
    api.get(`/news${cat === "all" ? "" : `?category=${encodeURIComponent(cat)}`}`).then((r) => setPosts(r.data)).catch(() => {});
  }, [cat]);

  return (
    <div data-testid="news-page">
      <section className="bg-gradient-to-br from-pink-50 via-white to-rose-50 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900">{t("news.title")}</h1>
          <p className="text-lg text-slate-600 mt-3 max-w-2xl">{t("news.sub")}</p>
          <div className="h-1 w-20 cupe-gradient rounded-full mt-4" />
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex gap-2 flex-wrap mb-8">
          {Array.isArray(cats) && cats.map((c) => (
            <button
              key={c}
              onClick={() => setCat(c)}
              className={`px-4 py-2 rounded-full text-sm font-semibold transition ${cat === c ? "cupe-gradient text-white" : "bg-white border border-slate-200 text-slate-700 hover:border-[#d81b7a]"}`}
              data-testid={`news-cat-${c}`}
            >
              {c === "all" ? t("common.all") : c}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {posts.map((p) => (
            <article key={p.id} className="bg-white border border-slate-200 rounded-2xl p-6 hover:shadow-lg transition-shadow" data-testid="news-article">
              <div className="text-xs uppercase tracking-widest text-[#d81b7a] font-semibold">{p.category}</div>
              <h3 className="font-display text-xl font-bold text-slate-900 mt-2">{lang === "fr" ? p.title_fr : p.title_en}</h3>
              <div className="text-xs text-slate-400 mt-1">{new Date(p.published_at).toLocaleDateString(lang === "fr" ? "fr-CA" : "en-CA", { year: "numeric", month: "long", day: "numeric" })}</div>
              <p className="text-slate-700 leading-relaxed mt-4">{lang === "fr" ? p.content_fr : p.content_en}</p>
              {(p.why_matters_en || p.why_matters_fr) && (
                <div className="mt-5 bg-pink-50/60 border-l-4 border-[#d81b7a] rounded-r-lg p-4">
                  <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-[#d81b7a] font-semibold mb-1">
                    <Sparkles size={14} /> {t("common.whyMatters")}
                  </div>
                  <p className="text-slate-700 text-sm">{lang === "fr" ? p.why_matters_fr : p.why_matters_en}</p>
                </div>
              )}
            </article>
          ))}
          {posts.length === 0 && <p className="text-slate-400 col-span-2">{t("home.noNews")}</p>}
        </div>
      </section>
    </div>
  );
}
